import 'react-day-picker/dist/style.css';

import React, {useState} from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {Tooltip, TooltipProps} from "../tooltip/tooltip";
import {TOOLTIP_PLACEMENT, TOOLTIP_TRIGGER} from "../tooltip/tooltip-consts";
import {DatePicker} from "./date-picker";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {Type} from "../../../infrastructure/type";
import {Z_INDEXES} from "../../consts";

export class DatePickerTooltipProps extends BaseProps {
  onChange: Function;
  selectedDate: Date;
  className: String;
  linkType: Type<BaseLinkModel>;
}

export const DatePickerTooltip = ({controller, onChange, onDateChange, onHide, onClickOutside, onShow, selectedDate, className, linkType, children}: DatePickerTooltipProps) => {
  const [instance, setInstance] = useState(null);

  const pickerProps = {
    controller,
    onChange: (date) => {
      instance.hide();
      onChange?.(date);
    },
    onDateChange: onDateChange,
    selectedDate: selectedDate,
    linkType: linkType,
  }

  const tooltipProps: TooltipProps = {
    className: className,
    trigger: TOOLTIP_TRIGGER.click,
    placement: TOOLTIP_PLACEMENT.bottom,
    hideArrow: true,
    interactive: true,
    ignoreDeviceWidth: true,
    content: <DatePicker {...pickerProps}/>,
    onCreate: (instance) => setInstance(instance),
    onClickOutside: () => {
      instance.hide();
      onClickOutside?.();
    },
    onShow: () => onShow?.(),
    onHide: () => onHide?.(),
    zIndex: Z_INDEXES.three,
    showDelay: 0,
    hideOnClick: true
  }

  return (
    <Tooltip {...tooltipProps}>
      {
        children
      }
    </Tooltip>
  )
}
